import { render, staticRenderFns } from "./ReminderCard.vue?vue&type=template&id=ccf6479e&scoped=true&"
import script from "./ReminderCard.vue?vue&type=script&lang=js&"
export * from "./ReminderCard.vue?vue&type=script&lang=js&"
import style0 from "./ReminderCard.vue?vue&type=style&index=0&id=ccf6479e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf6479e",
  null
  
)

export default component.exports